import ExpandTrigger from './ExpandTrigger';
export default ExpandTrigger;